// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: 190px;
  height: 100%;
}

.logo {
  width: 125px;
  position: absolute;
  top: 15px;
  left: 70px;
  cursor: pointer;
}
.side-menu-container-parent {
  position: relative;
  top: 85px;
  width: 210px;
  height: calc(100% - 100px);
  overflow-x: hidden;
  overflow-y: scroll;
}
#sidebar-new-shelf {
  margin-left: 20px;
  width: calc(100% - 80px);
  height: 30px;
  cursor: text;
  padding: 0px 10px;
  border-radius: 15px;
  font-size: 15px;
}
.side-menu-container-parent:hover::-webkit-scrollbar-thumb,
.side-menu-container-parent:active::-webkit-scrollbar-thumb,
.side-menu-container-parent:focus::-webkit-scrollbar-thumb {
  display: block;
  width: 1px;
}
.side-menu-container-parent::-webkit-scrollbar-thumb {
  display: none;
}
.side-menu-container-parent::-webkit-scrollbar {
  width: 2px;
  height: 0.5rem;
}
.sidebar-list {
  margin-right: 5px;
  font-size: 22px;
}
.sidebar-list-icon {
  width: 45px;
  height: 50px;
  position: absolute;
  top: 20px !important;
  left: 10px;
  cursor: pointer;
  font-size: 20px;

  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 5px;
  transition: 0.2s;
}
.sidebar-shelf-icon {
  font-size: 19px;
}
.sidebar-list-icon:hover {
  border-radius: 50%;
}
.side-menu-container {
  /* overflow: hidden; */
  width: 100%;
  padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
  box-sizing: content-box;
  position: relative;
}
.side-shelf-container {
  /* overflow: hidden; */
  width: 100%;
  padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */
  box-sizing: content-box;
  position: relative;
}
@media screen and (max-width: 950px) {
  .side-menu-container-parent {
    height: calc(100% - 155px);
  }
}
.side-menu-icon {
  /* float: left; */
  font-size: 22px;
  margin: 9px 12px 7px 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
}

.side-menu-item {
  margin-top: 2px;
  list-style-type: none;
  font-size: 15px;
  width: 100%;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: -20px;
  margin-bottom: 3px;
  position: relative;
  bottom: 1px;
  overflow: hidden;
  transition: 0.1s;
}
.side-menu-selector {
  width: 100%;
  height: 39px;
  /* line-height: 39px; */
  z-index: 40;
  display: flex;
  align-items: center;
  font-weight: 500;
}

.shelf-list-container-parent {
  margin-top: 20px;
  height: 140px;
  width: 80%;
}
.shelf-list-container {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  list-style-type: none;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}
.side-shelf-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 10px;
  display: inline-block;
}
.side-shelf-title-container {
  width: 70%;
  margin-left: 10%;
  border-bottom: 1px solid #ccc;
}
.side-shelf-title-icon {
  margin-top: 14px;
  float: right;
  font-weight: 500;
  font-size: 12px;
  transform-origin: center center;
  transition: transform 0.1s ease;
  cursor: pointer;
}
.side-menu-selector-container {
  width: 100%;
  height: 39px;
  border-radius: 25px;
  line-height: 39px;
  position: absolute;
  z-index: -1;
  animation: popup 0.1s ease-in-out 0s 1;
}
.icon-digest {
  font-size: 22px;
}
.side-menu-hover-container {
  width: 100%;
  height: 39px;
  border-radius: 25px;
  line-height: 39px;
  position: absolute;
  z-index: -1;
  animation: slidein 0.1s ease-in-out 0s 1;
}
@keyframes slidein {
  0% {
    opacity: 0;
    transform: scale(0.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
.side-menu-about {
  position: absolute;
  bottom: 0px;
}
.dropdown-icon-container {
  display: inline-block;
  margin-left: 13px;
}

.icon-idea {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;;;EAGE,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,eAAe;EACf,eAAe;;EAEf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB,EAAE,iEAAiE;EACtF,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB,EAAE,iEAAiE;EACtF,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,wCAAwC;AAC1C;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".sidebar {\n  width: 190px;\n  height: 100%;\n}\n\n.logo {\n  width: 125px;\n  position: absolute;\n  top: 15px;\n  left: 70px;\n  cursor: pointer;\n}\n.side-menu-container-parent {\n  position: relative;\n  top: 85px;\n  width: 210px;\n  height: calc(100% - 100px);\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n#sidebar-new-shelf {\n  margin-left: 20px;\n  width: calc(100% - 80px);\n  height: 30px;\n  cursor: text;\n  padding: 0px 10px;\n  border-radius: 15px;\n  font-size: 15px;\n}\n.side-menu-container-parent:hover::-webkit-scrollbar-thumb,\n.side-menu-container-parent:active::-webkit-scrollbar-thumb,\n.side-menu-container-parent:focus::-webkit-scrollbar-thumb {\n  display: block;\n  width: 1px;\n}\n.side-menu-container-parent::-webkit-scrollbar-thumb {\n  display: none;\n}\n.side-menu-container-parent::-webkit-scrollbar {\n  width: 2px;\n  height: 0.5rem;\n}\n.sidebar-list {\n  margin-right: 5px;\n  font-size: 22px;\n}\n.sidebar-list-icon {\n  width: 45px;\n  height: 50px;\n  position: absolute;\n  top: 20px !important;\n  left: 10px;\n  cursor: pointer;\n  font-size: 20px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 5px;\n  transition: 0.2s;\n}\n.sidebar-shelf-icon {\n  font-size: 19px;\n}\n.sidebar-list-icon:hover {\n  border-radius: 50%;\n}\n.side-menu-container {\n  /* overflow: hidden; */\n  width: 100%;\n  padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */\n  box-sizing: content-box;\n  position: relative;\n}\n.side-shelf-container {\n  /* overflow: hidden; */\n  width: 100%;\n  padding-right: 17px; /* Increase/decrease this value for cross-browser compatibility */\n  box-sizing: content-box;\n  position: relative;\n}\n@media screen and (max-width: 950px) {\n  .side-menu-container-parent {\n    height: calc(100% - 155px);\n  }\n}\n.side-menu-icon {\n  /* float: left; */\n  font-size: 22px;\n  margin: 9px 12px 7px 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n}\n\n.side-menu-item {\n  margin-top: 2px;\n  list-style-type: none;\n  font-size: 15px;\n  width: 100%;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-left: -20px;\n  margin-bottom: 3px;\n  position: relative;\n  bottom: 1px;\n  overflow: hidden;\n  transition: 0.1s;\n}\n.side-menu-selector {\n  width: 100%;\n  height: 39px;\n  /* line-height: 39px; */\n  z-index: 40;\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n}\n\n.shelf-list-container-parent {\n  margin-top: 20px;\n  height: 140px;\n  width: 80%;\n}\n.shelf-list-container {\n  width: 100%;\n  height: 100%;\n  overflow-y: scroll;\n  list-style-type: none;\n  cursor: pointer;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n.side-shelf-title {\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: inline-block;\n}\n.side-shelf-title-container {\n  width: 70%;\n  margin-left: 10%;\n  border-bottom: 1px solid #ccc;\n}\n.side-shelf-title-icon {\n  margin-top: 14px;\n  float: right;\n  font-weight: 500;\n  font-size: 12px;\n  transform-origin: center center;\n  transition: transform 0.1s ease;\n  cursor: pointer;\n}\n.side-menu-selector-container {\n  width: 100%;\n  height: 39px;\n  border-radius: 25px;\n  line-height: 39px;\n  position: absolute;\n  z-index: -1;\n  animation: popup 0.1s ease-in-out 0s 1;\n}\n.icon-digest {\n  font-size: 22px;\n}\n.side-menu-hover-container {\n  width: 100%;\n  height: 39px;\n  border-radius: 25px;\n  line-height: 39px;\n  position: absolute;\n  z-index: -1;\n  animation: slidein 0.1s ease-in-out 0s 1;\n}\n@keyframes slidein {\n  0% {\n    opacity: 0;\n    transform: scale(0.2);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n.side-menu-about {\n  position: absolute;\n  bottom: 0px;\n}\n.dropdown-icon-container {\n  display: inline-block;\n  margin-left: 13px;\n}\n\n.icon-idea {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
